import React from 'react'
import { BqIcon } from '@beeq/react'
import { Text } from '../../constants/TextConstants'
import PropTypes from 'prop-types'
import { GlobalSearchButton } from './styles'

/**
 * Will trigger handleSearch onBlur
 * @param {{ globalSearchParam?: string; handleSearch: (term: string)=>void; placeholder?: string }} props
 */
export default function GlobalSearch({ globalSearchParam, handleSearch, placeholder = Text.GlobalSearchPlaceholder }) {
  return (
    <GlobalSearchButton
      name='globalSearch'
      type='search'
      placeholder={placeholder}
      value={globalSearchParam}
      onBqChange={(e) => {
        handleSearch(e.detail.value)
      }}>
      <BqIcon name='magnifying-glass' size='24' slot='prefix'></BqIcon>
    </GlobalSearchButton>
  )
}

GlobalSearch.propTypes = {
  handleSearch: PropTypes.func.isRequired,
  globalSearchParam: PropTypes.string,
  placeholder: PropTypes.string
}
